<template>


  <v-number-input v-model="properties.quantita" label="Quantità" type="number" :min="1" :max="5" class="mb-6" />



  <v-text-field v-model="properties.ora_inizio" label="Ora inizio" class="mb-6" type="time" hide-details @update:model-value="update_hours_timestamps"/>
  <v-text-field v-model="properties.ora_fine" label="Ora fine" class="mb-6" type="time" hide-details @update:model-value="update_hours_timestamps"/>



  <v-number-input v-model="properties.distanza" label="Distanza minima raggiunta" type="number" :min="1"
      :max="2000" class="mb-6" />



  <v-card class="mt-0 mb-6 pa-3" :border="true" flat>
    <p class="text-headline-small mb-4">Documentazione</p>
    <v-switch v-model="properties.documentazione_video" label="Video" density="compact"
        class="flex-grow-0 mb-4" hide-details color="success" inset />
    <v-switch v-model="properties.documentazione_foto" label="Foto" density="compact"
        class="flex-grow-0 mb-4" hide-details color="success" inset />
    <v-switch v-model="properties.documentazione_disegno" label="Disegno" density="compact"
        class="flex-grow-0" hide-details color="success" inset />
  </v-card>

  <v-card class="mb-6 pa-3" :border="true" flat>
    <CardinalChooser label="Direzione" :resolution="22.5" class="outlined" v-model="properties.direzione__nome" :clearable="false" />
  </v-card>


  <v-select v-model="properties.sesso_id" :items="baseData.lookup.sesso" label="Sesso" item-title="label" hide-details
      class="mb-6" />

  <v-select v-model="properties.eta_id" :items="baseData.lookup.gipetoeta" label="Età" item-title="label" hide-details
      class="mb-6" />


  <v-select v-model="properties.comportamento_id" :items="baseData.lookup.gipetocomportamento"
      label="Comportamento principale" item-title="label" hide-details class="mb-6" />


  <v-card class="mb-6 pa-3" :border="true" flat>
    <p class="text-headline-small mb-4">Interazione</p>

    <v-select v-model="properties.interazione_specie_id" :items="baseData.lookup.gipetospecieinterazione"
        label="Altra specie" item-title="label" hide-details class="my-0" @update:modelValue="gipetoSpecieChanged" />

    <template v-if="![null, 1].includes(properties.interazione_specie_id)">
      <v-select v-model="properties.tipointerazione_id" :items="baseData.lookup.gipetotipointerazione" label="Tipo"
          item-title="label" hide-details class="mt-6" />

      <v-select v-model="properties.dominanteinterazione_id" :items="baseData.lookup.gipetodominanteinterazione"
          label="Dominante" item-title="label" hide-details class="mt-6" />
    </template>
  </v-card>



  <v-select v-model="properties.riproduzione_id" :items="baseData.lookup.gipetoriproduzione"
      label="Attività riproduttiva" clearable item-title="label" hide-details class="mb-6" />



  <v-card class="mt-0 mb-6 pa-3" :border="true" flat>

    <p class="text-headline-small mb-4">Anelli</p>
    <v-select v-model="properties.colore_anello_tarso_sx_id" :items="baseData.lookup.gipetocoloreanello" label="Tarso sinistro"
        item-title="label" hide-details class="mb-3" />
    <v-select v-model="properties.colore_anello_tarso_dx_id" :items="baseData.lookup.gipetocoloreanello" label="Tarso destro"
        item-title="label" hide-details class="mb-0" />
  </v-card>



  <v-card class="mt-0 mb-6 pa-3" :border="true" flat>


    <p class="text-headline-small">Marcatura</p>
    <FeatherMarker featherType="mar" v-model:properties="properties" />
  </v-card>

  <v-card class="mt-0 mb-6 pa-3" :border="true" flat>

    <p class="text-headline-small">Muta</p>
    <FeatherMarker featherType="muta" v-model:properties="properties" />
  </v-card>



  <SegnalazioneCommon v-model="properties" />

</template>

<script setup>

import { ref, onMounted } from 'vue'
import SegnalazioneCommon from "@/reports/components/SegnalazioneCommon";
import CardinalChooser from "@/reports/components/CardinalChooser"
import FeatherMarker from "@/reports/components/FeatherMarker"


import baseData from '@/assets/catalog/TrackerForms.json'

console.log(baseData)

// import { useDisplay } from 'vuetify'
// const { mobile } = useDisplay()

const properties = defineModel()

const props = defineProps({
  "isNew": {
    type: Boolean,
    default: false
  }
})

const gipetoSpecieChanged = (value) => {
  if ([null, 1].includes(value)) {
    delete properties.value.tipointerazione_id
    delete properties.value.dominanteinterazione_id
  }
  else {
    if (!properties.value?.tipointerazione_id) {
      properties.value.tipointerazione_id = baseData.lookup.gipetotipointerazione[0].value
    }
    if (!properties.value?.dominanteinterazione_id) {
      properties.value.dominanteinterazione_id = baseData.lookup.gipetodominanteinterazione[0].value
    }
  }
}


const now = new Date()
const oneHourAgo = new Date(now.getTime() - 60 * 60 * 1000)

const nowSplitted = now.toTimeString().split(":")
const oneHourAgoSplitted = oneHourAgo.toTimeString().split(":")






onMounted(() => {
  console.log("mounted")

  if (props.isNew) {
    properties.value.label = "Gipeto"

    properties.value.quantita = 1
    properties.value.ora_inizio = oneHourAgoSplitted[0] + ":" + oneHourAgoSplitted[1]
    properties.value.ora_fine = nowSplitted[0] + ":" + nowSplitted[1]
    properties.value.distanza = 100
    properties.value.documentazione_video = false
    properties.value.documentazione_foto = false
    properties.value.documentazione_disegno = false
    properties.value.direzione = null
    properties.value.sesso_id = baseData.lookup.sesso[0].value
    properties.value.eta_id = baseData.lookup.gipetoeta[0].value
    properties.value.comportamento_id = baseData.lookup.gipetocomportamento[0].value
    properties.value.interazione_specie_id = baseData.lookup.gipetospecieinterazione[0].value
    properties.value.tipointerazione_id = baseData.lookup.gipetotipointerazione[0].value
    properties.value.dominanteinterazione_id = baseData.lookup.gipetodominanteinterazione[0].value
    properties.value.riproduzione_id = baseData.lookup.gipetoriproduzione[0].value
    properties.value.colore_anello_tarso_sx_id = baseData.lookup.gipetocoloreanello[0].value
    properties.value.colore_anello_tarso_dx_id = baseData.lookup.gipetocoloreanello[0].value
  }


})



// "timestamp_start": 78600,
//   "timestamp_end": 80520

const update_hours_timestamps = (value) => {
  // "timestamp_start": 76920000,   // 21:22
  // "timestamp_end": 80520000,    // 22:22

  // if properties.value.ora_fine && properties.value.ora_inizio


  if (properties.value.ora_fine && properties.value.ora_inizio) {

    const ora_inizio = properties.value.ora_inizio.split(":")
    const ora_fine = properties.value.ora_fine.split(":")

    const timestamp_start = ora_inizio[0] * 3600 + ora_inizio[1] * 60
    const timestamp_end = ora_fine[0] * 3600 + ora_fine[1] * 60

    properties.value.timestamp_start = timestamp_start * 1000
    properties.value.timestamp_end = timestamp_end * 1000
  }


  if (properties.value.timestamp_start > properties.value.timestamp_end) {
    properties.value.ora_fine = properties.value.ora_inizio
    update_hours_timestamps()
    }

}







</script>
